import worldSVG from "../assets/world.svg";
import manageSVG from "../assets/manage.svg";
import calendarSVG from "../assets/calendar.svg";
import { Button, ButtonStyles } from "./Buttons";
import { useState } from "react";
import LazySVG, { LazySVGImportMap } from "./LazySVG";

export const UserProfileImage = ({ photoURL }: { photoURL?: string }) => (
  photoURL
    ? (
      <img src={photoURL} alt="Profile" width="30" height="30" className="rounded-md" />
    )
    : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 33 33"
        fill="none"
        className="rounded-md">
        <path
          d="M27.1213 29.7758H24.4661V27.1206C24.4661 26.0643 24.0465 25.0513 23.2996 24.3044C22.5527 23.5575 21.5396 23.1379 20.4833 23.1379H12.5178C11.4615 23.1379 10.4485 23.5575 9.70158 24.3044C8.95467 25.0513 8.53506 26.0643 8.53506 27.1206V29.7758H5.87988V27.1206C5.87988 25.3601 6.57923 23.6717 7.82409 22.4269C9.06894 21.182 10.7573 20.4827 12.5178 20.4827H20.4833C22.2438 20.4827 23.9322 21.182 25.1771 22.4269C26.4219 23.6717 27.1213 25.3601 27.1213 27.1206V29.7758ZM16.5006 17.8275C15.4545 17.8275 14.4187 17.6215 13.4523 17.2212C12.4859 16.8209 11.6078 16.2341 10.8681 15.4945C10.1284 14.7548 9.5417 13.8767 9.14139 12.9103C8.74109 11.9439 8.53506 10.908 8.53506 9.862C8.53506 8.81595 8.74109 7.78015 9.14139 6.81373C9.5417 5.84731 10.1284 4.9692 10.8681 4.22953C11.6078 3.48986 12.4859 2.90313 13.4523 2.50282C14.4187 2.10252 15.4545 1.89648 16.5006 1.89648C18.6132 1.89648 20.6392 2.73571 22.133 4.22953C23.6269 5.72335 24.4661 7.74941 24.4661 9.862C24.4661 11.9746 23.6269 14.0006 22.133 15.4945C20.6392 16.9883 18.6132 17.8275 16.5006 17.8275ZM16.5006 15.1723C17.909 15.1723 19.2597 14.6129 20.2556 13.617C21.2514 12.6211 21.8109 11.2704 21.8109 9.862C21.8109 8.45361 21.2514 7.1029 20.2556 6.10702C19.2597 5.11114 17.909 4.55166 16.5006 4.55166C15.0922 4.55166 13.7415 5.11114 12.7456 6.10702C11.7497 7.1029 11.1902 8.45361 11.1902 9.862C11.1902 11.2704 11.7497 12.6211 12.7456 13.617C13.7415 14.6129 15.0922 15.1723 16.5006 15.1723Z"
          fill="url(#paint0_linear_2_12820)" />
        <defs>
          <linearGradient
            id="paint0_linear_2_12820"
            x1="7.6323"
            y1="5.98225"
            x2="28.4654"
            y2="7.22396"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#4AFC2D" />
            <stop offset="1" stopColor="#1EA707" />
          </linearGradient>
        </defs>
      </svg>
    )
)

// ====================================
// PageTitle
// This needs to be updated to use a better icon system (doesn't exist yet).
// Also, we don't know if we want to name this differently because it's specifically here for the refresh part. It's not just a title.
// ====================================
export const PageTitle = (props: { icon?: string, title: string }) =>
  <h1 className="flex items-center justify-center text-center gap-x-4 text-[24px]">
    {props.icon && <PageTitleIcon icon={props.icon} />} {props.title}
  </h1>

const PageTitleIcon = (props: { icon: string }) =>
  <div className="hidden xl:inline-flex items-center justify-center h-fit w-fit rounded-[11px] bg-[#343434] bg-opacity-40 p-[8px]">
    <img src={props.icon} alt="icon" className="lg:w-[24px] lg:h-[24px] xl:w-[32px] xl:h-[32px]" />
  </div>



// ====================================
// AccoladesList
// ====================================
const AccoladeList = [
  { text: "Merge RTK Networks Worldwide", description: "Access dedicated tools to create, manage and merge RTK networks based on your criteria.", image: worldSVG },
  { text: "Manage Your Team", description: "Manage individual licenses and credentials for your team or organisation.", image: manageSVG },
  { text: "Flexible Subscriptions", description: "Choose subscription plans ranging from a single day to a yearly subscription.", image: calendarSVG },
];


const Accolade = ({ text, description, image }: { text: string, description: string, image?: string }) => {
  // SKYLAR: all the 2xl: settings here are meant to be lg: but the sidebar got in the way and needed the breaks sooner :)

  return (
    <div className="flex flex-col gap-x-4 text-center items-center 2xl:text-left 2xl:items-start">
      {image
        ? <img src={image} alt={text} width="52" height="52" />
        : <div className="w-10 h-10 rounded-full" style={{ background: "linear-gradient(-45deg in lch, rgb(0, 255, 34), rgb(0, 155, 39))" }}></div>}
      <h3 className="text-[20px] mt-2 mb-2">{text}</h3>
      <p className="dark:text-darkMode-secondaryText max-w-[70%]">{description}</p>
    </div>
  )
}

export const AccoladesBlock = () => {
  return (
    <div className="flex flex-col gap-y-10">
      {AccoladeList.map((accolade, index) => <Accolade key={index} text={accolade.text} description={accolade.description} image={accolade.image} />)}
    </div>
  )
}


// ====================================
// AlertIcon
// ====================================
type AlertTypes = "success" | "warning" | "error" | "info";
export const AlertIcon = ({ type }: { type: AlertTypes }) => {
  const picks: Record<AlertTypes, { Icon: string, bgColor: string }> = {
    success: { Icon: "SuccessIcon", bgColor: "dark:bg-darkMode-success" },
    warning: { Icon: "WarningIcon", bgColor: "dark:bg-darkMode-warning" },
    error: { Icon: "WarningIcon", bgColor: "dark:bg-darkMode-error" },
    info: { Icon: "InfoIcon", bgColor: "dark:bg-darkMode-info" },
  }

  const { Icon, bgColor } = picks[type]

  return (
    <div className="flex items-center justify-center">
      <div className={`w-20 h-20 flex items-center justify-center rounded-full ${bgColor}`}>
        <LazySVG name={Icon as LazySVGImportMap} className="dark:text-darkMode-primaryText" width={46} height={46} />
      </div>
    </div>
  )
}

// ====================================
// MiniStatsCard
// ====================================
type MiniStatCardProps = {
  title: string
  value: string | number
  cardColor?: MiniStatCardColors
}

type MiniStatCardColors = "success" | "warning" | "error" | "muted" | "default"

const cardColorClasses: Record<MiniStatCardColors, string> = {
  success: "dark:bg-darkMode-successDark",
  warning: "dark:bg-darkMode-warningDark",
  error: "dark:bg-darkMode-error",
  muted: "dark:bg-darkMode-layer3color",
  default: "dark:bg-darkMode-quickLookStatBg",
};


export const MiniStatCard = ({ title, value, cardColor = "default" }: MiniStatCardProps) => {


  return (
    <div className={`${cardColorClasses[cardColor]} p-4 flex flex-col justify-between rounded-md`}>
      <p className="font-bold text-[20px] lg:text-[24px]">{value}</p>
      <p className="dark:text-darkMode-secondaryText">{title}</p>
    </div>
  )
}

// ====================================
// Progress / Steps Accolades
// ====================================

interface Step {
  label: string;
  description?: string;
}

interface StepAccoladesProps {
  steps: Step[];
  currentStep: number;
  onStepClick?: (index: number) => void;
}

const StepAccolades: React.FC<StepAccoladesProps> = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="flex flex-col md:flex-row items-start justify-between w-full relative gap-x-4 gap-y-6">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`flex items-center justify-between md:items-start flex-col text-center md:text-left mx-auto lg:mx-0 relative ${onStepClick ? 'cursor-pointer' : ''}`}
          onClick={() => onStepClick?.(index)}
        >
          {/* Step Number */}
          <div
            className={`w-10 h-10 flex items-center justify-center rounded-full border-2 font-bold ${index <= currentStep ? 'dark:border-darkMode-primary dark:bg-darkMode-primary dark:text-darkMode-primaryText' : 'dark:border-darkMode-muted dark:bg-darkMode-muted dark:text-darkMode-primaryText'}`}
          >
            {index + 1}
          </div>

          {/* Step Label */}
          <p className={`font-semibold ${index <= currentStep ? 'dark:text-darkMode-primary' : 'dark:text-darkMode-muted'}`}>{step.label}</p>

          {/* Step Details */}
          {step.description && (
            <p className="text-[14px] mt-2">{step.description}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default StepAccolades;


// ====================================
// CTA Card / Block
// ====================================
type CTACardBase = {
  title: string
  icon?: React.ReactNode
  description?: string
  buttonLabel: string
  onClick: () => void;
  buttonDisabled?: boolean
  buttonStyle?: ButtonStyles
}

type CTACardProps = CTACardBase & {
  large?: boolean
}

export const CTACard = ({ title, icon, description, buttonLabel, onClick, large, buttonDisabled, buttonStyle }: CTACardProps) => {
  return (
    <div className="border rounded-md dark:border-darkMode-layer1border dark:bg-darkMode-layer1color border-opacity-65 p-4 pt-6 gap-1 h-full w-full flex flex-col justify-between items-center">
      {icon &&
        <div className={`${large ? "w-[4.5rem] h-[4.5rem]" : "w-14 h-14"}  flex items-center justify-center rounded-full dark:bg-darkMode-primary`}>
          {icon}
        </div>}

      <h2 className={`text-center font-bold ${large && "text-[18px]"}`}>{title}</h2>
      {description !== "" && <p className="dark:text-darkMode-muted text-center mb-2 break-words">{description}</p>}
      <Button label={buttonLabel} onClick={onClick} buttonStyle={buttonStyle || "primary"} alwaysFullWidth={!large} disabled={buttonDisabled} buttonCustomClasses="max-w-[300px]" />
    </div>
  )
}

type CTACardLargeProps = CTACardBase & {

}
export const CTACardLarge = ({ title, icon, description, buttonLabel, onClick, buttonDisabled, buttonStyle }: CTACardLargeProps) => {
  return (
    <div className="border rounded-md dark:border-darkMode-layer1border dark:bg-darkMode-layer1color border-opacity-65 p-4 gap-8 h-full w-full flex flex-col justify-center items-center">
      {icon &&
        <div className="w-20 h-20 flex items-center justify-center rounded-full dark:bg-darkMode-primary">
          {icon}
        </div>}

      <h2 className="text-center font-bold text-[18px]">{title}</h2>
      {description !== "" && <p className="dark:text-darkMode-muted text-center break-words max-w-[580px]">{description}</p>}

      <Button label={buttonLabel} onClick={onClick} buttonStyle={buttonStyle || "primary"} alwaysFullWidth disabled={buttonDisabled} buttonCustomClasses="max-w-[300px]" size="large" />
    </div>
  )
}


// ====================================
// SmallPromoteCard
// ====================================
type SmallPromoteCardProps = {
  title: string
  description?: string
  buttonLabel: string
  onClick: () => void;
  large?: boolean
}

export const SmallPromoteCard = ({ title, description, buttonLabel, onClick, large }: SmallPromoteCardProps) => {

  return (
    <div className="rounded-lg dark:border-darkMode-info border-2 py-2.5 px-4">
      <div className={`flex flex-col ${!large && "2xl:flex-row"} gap-2 justify-between items-center`}>
        <div className="text-center 2xl:text-left">
          <h3 className=" font-semibold">{title}</h3>
          {description && <p className="dark:text-darkMode-muted text-[14px]">{description}</p>}
        </div>

        <Button label={buttonLabel} onClick={onClick} buttonStyle="tertiary" size="small" />
      </div>
    </div>
  );
}


// ====================================
// TabSwitcher
// ====================================
type TabOption<T> = {
  label: string;
  value: T;
};

interface TabSwitchProps<T> {
  options: TabOption<T>[];
  onSelect: (value: T) => void;
  initialSelected?: string;
}

export const TabSwitch = <T extends string>({ options, onSelect, initialSelected }: TabSwitchProps<T>) => {
  const [selected, setSelected] = useState(initialSelected || options[0].value);

  const handleClick = (value: T) => {
    setSelected(value);
    onSelect(value);
  };

  return (
    <div className="relative w-full max-w-md mx-auto">
      <div className="flex justify-between border dark:border-darkMode-layer3border rounded-[20px] py-[5px]">
        <div
          className="absolute top-[5px] bottom-[5px] left-[5px] dark:bg-darkMode-primary rounded-[17px] transition-transform duration-300"
          style={{
            width: `calc(${100 / options.length}% - 6px)`,
            transform: `translateX(calc(${options.findIndex((option) => option.value === selected) * 100}% + ${options.findIndex((option) => option.value === selected) * 6 - 3}px))`,
          }} />
        {options.map((option, index) => (
          <div key={option.value} className="relative flex-1">
            <button
              onClick={() => handleClick(option.value)}
              className={`relative w-full py-2 text-center font-semibold rounded-full focus:outline-none transition-colors duration-300 ${selected === option.value ? 'dark:text-darkMode-primaryText' : 'dark:text-white'
                }`}>
              {option.label}
            </button>
            {index < options.length - 1 && (
              <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-[2px] h-3/4 dark:bg-darkMode-layer3color"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};